/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import ReactMarkdown from 'react-markdown'

const markdownCss = css`
  display: inline;
  a {
    color: #4384f5;
  }
`

const LinkRenderer = (props) => {
  return (
    <a href={props.href} target="_blank" rel="noopener noreferrer">
      {props.children}
    </a>
  )
}

const MarkdownRenderer = ({ children }) => {
  return (
    <ReactMarkdown
      unwrapDisallowed
      allowedElements={['a']}
      components={{ a: LinkRenderer }}
      css={markdownCss}
    >
      {children}
    </ReactMarkdown>
  )
}

export default MarkdownRenderer
